export default __webpack_public_path__ + "static/media/delivery-icon.dbfcbc9a.svg";